<template>
  <div class="file-upload">
    <el-upload ref="fileUpload" :http-request="httpRequest" :accept="accept" :on-change="change"
               :show-file-list="false" :auto-upload="false" :multiple="multiple" :drag="drag" action="" :disabled="disabled">
      <slot />
    </el-upload>
  </div>
</template>

<script>
export default {
  name: 'FileUpload',
  props: {
    accept: { type: String },
    multiple: { type: Boolean, default: false },
    drag: { type: Boolean, default: false },
    limit: { type: Number },
    size: { type: Number },
    sizeInfo: { type: String },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      file: this.$store.state.file,
      fileData: undefined,
      uploadFiles: [],
      filePathList: [],
      fileValid:true,
    }
  },
  created() {},
  mounted() {
    this.uploadFiles = this.$refs.fileUpload.uploadFiles
  },
  watch: {
    showFileList(newValue, oldValue) {
      if (this.limit !== undefined) {
        if (this.filePathList.length > this.limit && this.uploadFiles.length > 0) {
          this.uploadFiles.splice(0, this.uploadFiles.length)
          this.$emit('exceed')
          return
        }
        if (this.uploadFiles.length + this.filePathList.length > this.limit && this.uploadFiles.length > 0) {
          this.uploadFiles.splice(this.limit - this.filePathList.length, this.uploadFiles.length - (this.limit - this.filePathList.length))
          this.$emit('exceed')
          return
        }
      }
      if (JSON.stringify(newValue) === JSON.stringify(oldValue)) return
      this.$emit('showFileList', newValue)
    },
  },
  computed: {
    showFileList() {
      let showFileList = []
      for (let i = 0, length = this.filePathList.length; i < length; i++) {
        showFileList.push(this.filePathList[i].fileName)
      }
      for (let i = 0, length = this.uploadFiles.length; i < length; i++) {
        showFileList.push(this.uploadFiles[i].name)
      }
      return showFileList
    },
  },
  methods: {
    setInitFilePathList(filePathList) {
      this.filePathList = filePathList
    },
    change(file) {
      //判定文件类型
      this.fileValid = this.beforeUpload(file)
      if (this.fileValid === true){
        this.$emit('fileUrl', window.URL.createObjectURL(file.raw))
      }else{
        this.deleteIndex(this.uploadFiles.length-1)
      }
    },
    deleteIndex(index) {
      if (index < this.filePathList.length) {
        this.filePathList.splice(index, 1)
        return
      }
      this.uploadFiles.splice(index - this.filePathList.length, 1)
    },
    submit(uid) {
      if (this.uploadFiles.length > 0) {
        this.fileData = new FormData()
        this.$refs.fileUpload.submit()
        this.$system.uploadFile(this.file + '/files/uploadFile?uid=' + uid, this.fileData, this.submitSuccess, this.error)
      } else {
        this.$emit('success', this.filePathList)
      }
    },
    httpRequest(params) {
      this.fileData.append('file', params.file)
    },
    submitSuccess(data) {
      if (data.type === '00') {
        this.uploadFiles.splice(0, this.uploadFiles.length)
        for (let i = 0, length = data.filePathList.length; i < length; i++) {
          this.filePathList.push(data.filePathList[i])
        }
        this.$emit('success', this.filePathList)
      } else if (data.type === '99') {
        this.$router.push({ name: 'ErrorPage', params: { mess: data.mess } })
      } else {
        this.$system.notify('错误', data.mess, 'error')
        this.$emit('error')
      }
    },
    error() {
      this.$system.notify('错误', '网络连接失败', 'error')
      this.$emit('error')
    },
    beforeUpload: function (file) {
      let prefix = file.name.substring(file.name.lastIndexOf('.'))
      let isImg = this.accept.indexOf(prefix) != -1
      if (!isImg) {
        let acceptInfo = this.accept.replaceAll('.', '').replaceAll(',', '、')
        this.$system.notify('错误', '请上传格式为'+ acceptInfo +'的文件', 'error')
      }
      let isLtSize = parseFloat(file.size) < this.size
      if (!isLtSize) {
        this.$system.notify('错误', '上传文件大小不能超过'+ this.sizeInfo, 'error')
      }
      return isImg && isLtSize
    },
  },
}
</script>

<style lang="less" scoped>
.file-upload {
  display: inline-block;
}
</style>

